import React from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "./Button";

const Footer = () => {
  const { pathname } = useLocation();
  if (pathname === "/qr-editor") return null;

  const companyLinks = [
    // { label: "Who we are", to: "/who-we-are" },
    // { label: "Terms and Conditions", to: "/terms-and-conditions" },
    // { label: "Terms of Use", to: "/terms-of-use" },
    // { label: "Privacy policy", to: "/privacy-policy" },
    // { label: "Cookies policy", to: "/cookies-policy" },
    // { label: "Prices", to: "/pricing" },
    { label: "Who we are", to: "/" },
    { label: "Terms and Conditions", to: "/" },
    { label: "Terms of Use", to: "/" },
    { label: "Privacy policy", to: "/" },
    { label: "Cookies policy", to: "/" },
    { label: "Prices", to: "/" },
  ];

  const helpLinks = [
    // { label: "Contact us", to: "/contact-us" },
    { label: "FAQ", to: "/faq" },
    { label: "Contact us", to: "/" },
    // { label: "FAQ", to: "/" },
  ];

  return (
    <footer>
      <div className="top">
        <div className="left">
          {/* <h1 className="logo_heading">INTEGRATED QR</h1> */}
          <img
            src="/assets/images/integrated_qr_logo_dark-removebg-preview.png"
            alt="logo"
            // width={70}
            // height={70}
          />
        </div>
        <div className="right">
          <div className="one">
            <h1>Company</h1>
            {companyLinks.map(({ label, to }) => (
              <Link
                key={label}
                to={label === "Prices" ? "/#pricingPlanSecID" : to}
              >
                <p>{label}</p>
              </Link>
            ))}
          </div>
          <div className="one">
            <h1>Need help?</h1>
            {helpLinks.map(({ label, to }) => (
              <Link key={to} to={to}>
                <p>{label}</p>
              </Link>
            ))}
          </div>
          <div className="one">
            <div className="wrap">
              <h3>Make your own QR codes today.</h3>
              <Button title="Generate QR Code" redirect="/qr-editor" />
            </div>
          </div>
        </div>
      </div>
      <div className="bottom">
        <p>© 2024 integratedqr.com All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
